import { FC } from 'react';
import LocalAtm from '@mui/icons-material/LocalAtm';
import TabsPanel from 'further-ui/components/TabsPanel';
import { LP_CAPITAL_ACTION_CREATE } from 'adminConstants/routes';
import Page from 'components/new/Page';
import CapitalActionsSummary from './CapitalActionsSummary';
import CapitalActions from './CapitalActions';
import OutstandingCalls from './OutstandingCalls';
import { useLayoutContext } from 'contexts/LayoutContext';
import api from 'lib/trpcClient';
import { useFlag } from '@reflag/react-sdk';

const ListCapitalActions: FC = () => {
  const { vehicle } = useLayoutContext();
  const vehicleId = vehicle?._id ?? '';
  const { isEnabled: showBankRecDataInCapitalNotices } = useFlag(
    'show-bank-rec-data-in-capital-notices',
  );
  const [{ capitalActions, outstandingCallsByInvestor, ...summaryData }] =
    api.capitalAction.getVehicleCapitalActionsSummary.useSuspenseQuery({
      vehicleId,
    });

  const tabs = [
    {
      key: 'capital-actions',
      label: 'Capital actions',
      content: <CapitalActions capitalActions={capitalActions ?? []} />,
    },
    ...(showBankRecDataInCapitalNotices
      ? [
          {
            key: 'outstanding-calls',
            label: 'Outstanding calls',
            content: (
              <OutstandingCalls
                currencyLcy={vehicle?.baseCurrency}
                dataByInvestor={outstandingCallsByInvestor}
                vehicleId={vehicleId}
              />
            ),
          },
        ]
      : []),
  ];

  return (
    <Page
      tabTitle="Capital actions"
      heading="Capital actions"
      headingIcon={LocalAtm}
      withHeadingDivider
      spacing="lg"
      actions={[
        {
          label: 'Start new action',
          link: LP_CAPITAL_ACTION_CREATE,
          variant: 'contained',
        },
      ]}
    >
      <CapitalActionsSummary
        baseCurrency={vehicle?.baseCurrency}
        {...summaryData}
      />
      <TabsPanel keepAlive useTabsUrls tabs={tabs} />
    </Page>
  );
};

export default ListCapitalActions;
